import { Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-footer-content-col',
  styleUrl: 'spw-footer-content-col.scss',
  shadow: true,
})
export class SpwFooterContentCol {
  /** Titre de la colonne */
  @Prop() colTitle?: string;

  render() {
    return (
      <Host>
        {this.colTitle && <h2 class="spw-footer-content-col__title">{this.colTitle}</h2>}
        <slot></slot>
      </Host>
    );
  }
}
